import React, { useEffect, useState, useMemo } from 'react';
import './Billing.scss';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatPhoneNo } from '../../../helpers/common';
import * as intrfce from '../Interfaces';

export interface iFormBillingDetails {
    firstNameBilling: string;
    lastNameBilling: string;
    contactBilling: string;
}
export interface BillingAddessProps {
    userType: string | undefined;
  onInputChange: (fieldName: string, value: any) => void;
  onFieldBlur?: (fieldName: string, value: any) => void;
    formBillingAddress: intrfce.iAddressFormData;
    validationErrors: Record<string, string>;
    billingUser: any;
    isReadOnly: boolean
}
const Billing: React.FC<BillingAddessProps> = ({ userType, onInputChange, onFieldBlur, formBillingAddress, isReadOnly, validationErrors, billingUser }) => {
    // Extract billing details from formBillingAddress
    const formBillingDetails = useMemo(() => ({
        firstNameBilling: formBillingAddress?.firstName || "",
        lastNameBilling: formBillingAddress?.lastName || "",
        contactBilling: formBillingAddress?.contact || ""
    }), [formBillingAddress?.firstName, formBillingAddress?.lastName, formBillingAddress?.contact]);
    const { t } = useTranslation();
    const handleFieldChange = (fieldName: string, value: any) => {
        onInputChange(fieldName, value); // Notify the parent component about the form change
    };
    const handleFieldBlur = (fieldName: string, value: any) => {
        if (onFieldBlur) {
            onFieldBlur(fieldName, value); // Notify the parent component about blur for validation
        }
    };
    const [userData, setUserData] = useState<iFormBillingDetails | undefined>(undefined);
    useEffect(() => {

        if (billingUser) {
            setUserData({
                ...userData,
                firstNameBilling: billingUser.firstName,
                lastNameBilling: billingUser.lastName,
                contactBilling: billingUser.phoneNumber
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billingUser]);
    return (
       <div className="Billing" role="region" aria-labelledby="billingSectionHeader">
         <h3 id="billingSectionHeader" className="visually-hidden">{t('BILLING_INFORMATION')}</h3>
         <Col md={6}>
           <Form.Group controlId="firstNameBilling">
             <Form.Label className='visually-hidden' htmlFor="firstNameBilling">{t('FIRST_NAME')}</Form.Label>
             <Form.Control
               id="firstNameBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.firstNameBilling}
               aria-describedby={validationErrors.firstNameBilling ? "firstNameBillingError" : undefined}
               placeholder={t('FIRST_NAME_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
              name="firstNameBilling"
              readOnly={isReadOnly}
              value={formBillingDetails.firstNameBilling}
              onBlur={(e) => handleFieldBlur('firstNameBilling', e.target.value)}
              onChange={(e) => handleFieldChange('firstNameBilling', e.target.value)}
              isInvalid={!!validationErrors.firstNameBilling}
             />
             <Form.Control.Feedback type="invalid" id="firstNameBillingError" aria-live="polite">
               {validationErrors.firstNameBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
         <Col md={6}>
           <Form.Group controlId="lastNameBilling">
             <Form.Label className='visually-hidden' htmlFor="lastNameBilling">{t('LAST_NAME')}</Form.Label>
             <Form.Control
               id="lastNameBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.lastNameBilling}
               aria-describedby={validationErrors.lastNameBilling ? "lastNameBillingError" : undefined}
               placeholder={t('LAST_NAME_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
              name="lastNameBilling"
              readOnly={isReadOnly}
              value={formBillingDetails.lastNameBilling}
              onBlur={(e) => handleFieldBlur('lastNameBilling', e.target.value)}
              onChange={(e) => handleFieldChange('lastNameBilling', e.target.value)}
              isInvalid={!!validationErrors.lastNameBilling}
             />
             <Form.Control.Feedback type="invalid" id="lastNameBillingError" aria-live="polite">
               {validationErrors.lastNameBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
         <Col md={6}>
           <Form.Group controlId="contactBilling">
             <Form.Label className='visually-hidden' htmlFor="contactBilling">{t('PHONE_NUMBER')}</Form.Label>
             <Form.Control
               id="contactBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.contactBilling}
               aria-describedby={validationErrors.contactBilling ? "contactBillingError" : undefined}
               placeholder={t('PHONE_NUMBER_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
              name="contactBilling"
              readOnly={isReadOnly}
              value={formatPhoneNo(formBillingDetails.contactBilling)}
              onBlur={(e) => handleFieldBlur('contactBilling', e.target.value)}
              onChange={(e) => handleFieldChange('contactBilling', e.target.value)}
              isInvalid={!!validationErrors.contactBilling}
             />
             <Form.Control.Feedback type="invalid" id="contactBillingError" aria-live="polite">
               {validationErrors.contactBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
       </div>
    )
}
export default Billing;